import { Label, TooltipDesktop, UIText2 } from '@cian/ui-kit';
import { IconHighDemand16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './styles.css';

export function DiscountMortgageLabel() {
  return (
    <TooltipDesktop
      title={
        <UIText2 color="white_100">
          Подробнее узнавайте <br /> у застройщика
        </UIText2>
      }
      theme="black"
    >
      <div className={styles['label']}>
        <Label
          background="var(--decorative__accent__lavender_transparent)"
          color="var(--decorative__accent__purple)"
          icon={<IconHighDemand16 color="decorative__accent__purple" />}
        >
          Льготная ипотека
        </Label>
      </div>
    </TooltipDesktop>
  );
}
